// extracted by mini-css-extract-plugin
export default {"details":"InvoiceDetails_details__zF-Wu"};